import { HttpResult } from 'widgets-for-react'

export const parseResponse = async (
  response: Promise<Response>
): Promise<HttpResult<{}>> => {
  const res = await response
  if (res.ok) return { kind: 'result', status: res.status, value: {} }
  return { kind: 'failed', status: res.status }
}

export const tryParseJsonResponse = async (
  response: Promise<Response>
): Promise<HttpResult<any>> => {
  const res = await response
  if (res.ok) {
    try {
      const json = await res.json()
      return { kind: 'result', status: res.status, value: json }
    } catch {
      return { kind: 'failed', status: res.status }
    }
  }
  return { kind: 'failed', status: res.status }
}
